module.exports = __webpack_public_path__ + "static/material-dialog-22c52b8132e9434e6a5385c61d7b6c30.png";